import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeSearchResultsLook = 'searchresults-live-toggle';

export const isWedgeSearchResultsLook = (look: string): look is WedgeSearchResultsLook => look === 'searchresults-live-toggle';

/* Released Live and Recent disclosure row of the typed search, off-scale. It is a full-width flex row that spreads a section header and a
   chevron with an 8px gap, `2px 0` padding, no fill and no border, and it inherits the type of its parent and then sets the Wedge font family,
   in the source declaration order. The text aligns left. It draws no transparent target (wedgeSearchResultsDrawsHit): the open pane starts 4px
   below the row, so a 44px region would cover the first row of that pane, and the anchor would add a positioned box that legacy does not have. */
export const wedgeSearchResultsDrawsHit = (look: string): boolean => !isWedgeSearchResultsLook(look);

export function wedgeSearchResultsStyle(_look: WedgeSearchResultsLook): CSSProperties {
  return {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, width: '100%', padding: '2px 0',
    background: 'none', border: 0, cursor: 'pointer', font: 'inherit', fontFamily: wedgeExactRole('font'), textAlign: 'left',
  };
}
